import React from 'react';
import { Navigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useCanAccess } from '../../context/PermissionsContext';

/**
 * Guarda rutas según permiso. Si el usuario no tiene el permiso, muestra
 * un mensaje de acceso denegado.
 * @param {string} permission - 'dashboard' | 'users' | 'settings'
 * @param {React.ReactNode} children
 * @param {string} [redirectTo] - Ruta a la que redirigir si no tiene acceso
 */
export function RouteGuard({ permission, children, redirectTo }) {
  const canAccess = useCanAccess(permission);
  if (canAccess) return children;
  if (redirectTo) return <Navigate to={redirectTo} replace />;
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center px-4">
      <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
        <AlertTriangle className="h-8 w-8 text-amber-600" />
      </div>
      <h2 className="text-2xl font-bold text-slate-900 mb-2">Acceso restringido</h2>
      <p className="text-slate-500 max-w-md">
        No tienes permiso para ver esta sección. Solicita a un administrador que active el acceso desde <strong>Usuarios → Permisos</strong>.
      </p>
    </div>
  );
}
